import katex from "katex";

function renderMathElement(element, { displayMode }) {
  const latex = element.getAttribute("data-latex") || "";
  if (!latex) {
    return;
  }

  try {
    element.innerHTML = katex.renderToString(latex, {
      throwOnError: false,
      displayMode,
      output: "html",
    });
    element.classList.add("tiptap-mathematics-render");
    if (displayMode) {
      element.classList.add("katex-display");
    }
  } catch (e) {
    element.textContent = latex;
  }
}

export function renderMathInHtml(html) {
  if (!html || typeof document === "undefined") {
    return html || "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
  const container = doc.body.firstElementChild;

  if (!container) {
    return html;
  }

  container.querySelectorAll('[data-type="block-math"]').forEach((element) => {
    renderMathElement(element, { displayMode: true });
  });

  container.querySelectorAll('[data-type="inline-math"]').forEach((element) => {
    renderMathElement(element, { displayMode: false });
  });

  return container.innerHTML;
}
